import { component } from 'picoapp'
import imagesLoaded from 'imagesloaded'

class MarqueeLogos {
  constructor(node, ctx) {
    // bindings

    // selectors
    this._node = node;

    imagesLoaded(this._node, (instance) => {
      this._node.classList.remove('loading');
    });

    // unmount
    return this.unmount.bind(this)
  }

  //
  // Unmount.
  //
  unmount() {
    // events
  }
}

export default component((node, ctx) => new MarqueeLogos(node, ctx))
